import { ILayoutState } from '@/redux/store.interface'

export const layoutReducer = (): ILayoutState => ({
  snackbar: {},
})
